const ORIGIN = "https://amalfivibes.com";

const upsert = (sel, make) => document.head.querySelector(sel) || document.head.appendChild(make());

const HL = { pt: "pt-BR", ko: "ko-KR" };
export function setHead({ title, description, path, alternates = {}, jsonld, image, noindex, lang }) {
  document.title = title;
  if (lang) document.documentElement.lang = HL[lang] || lang;
  const meta = (attr, key, val) => { const m = upsert(`meta[${attr}="${key}"]`, () => Object.assign(document.createElement("meta"), { [attr === "name" ? "name" : "content"]: "" })); m.setAttribute(attr, key); m.setAttribute("content", val || ""); };
  meta("name", "description", description);
  meta("property", "og:title", title);
  meta("property", "og:description", description);
  meta("property", "og:url", ORIGIN + path);
  if (image) meta("property", "og:image", image.startsWith("http") ? image : ORIGIN + image);
  let c = document.head.querySelector('link[rel="canonical"]');
  if (!c) { c = document.createElement("link"); c.rel = "canonical"; document.head.appendChild(c); }
  c.href = ORIGIN + path;
  document.head.querySelectorAll("[data-mag]").forEach((n) => n.remove());
  const add = (el) => { el.setAttribute("data-mag", "1"); document.head.appendChild(el); };
  const keys = Object.keys(alternates);
  if (keys.length > 1) {
    keys.forEach((l) => add(Object.assign(document.createElement("link"), { rel: "alternate", hreflang: HL[l] || l, href: ORIGIN + alternates[l] })));
    add(Object.assign(document.createElement("link"), { rel: "alternate", hreflang: "x-default", href: ORIGIN + (alternates.en || alternates[keys[0]]) }));
  }
  if (noindex) add(Object.assign(document.createElement("meta"), { name: "robots", content: "noindex, follow" }));
  if (jsonld) { const s = document.createElement("script"); s.type = "application/ld+json"; s.textContent = JSON.stringify(jsonld); add(s); }
}

export const ORG = { "@type": "Organization", name: "AMALFI VIBES", url: ORIGIN, logo: `${ORIGIN}/icon-512.png` };
export const abs = (p) => (p?.startsWith("http") ? p : ORIGIN + p);
